import { ManagerPaycloud } from "../../types";
import { useFlowPages } from "../../hooks/useFlowPages";

interface EditManagerFormProps {
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  manager: ManagerPaycloud;
  fetchManagers?: () => Promise<void>;
}

/**
 * Componente wrapper que renderiza el formulario de edición de manager
 * según el país del usuario (Argentina o República Dominicana)
 */
export function EditManagerForm({
  setIsModalOpen,
  manager,
  fetchManagers,
}: EditManagerFormProps) {
  const FormComponent = useFlowPages({
    page: 'editManagerForm',
    props: {
      setIsModalOpen,
      manager,
      fetchManagers,
    }
  });

  return <>{FormComponent}</>;
}
